import { useLang } from "@/context/LanguageContext";
import { serviceWaLink } from "@/lib/whatsapp";
import { GoldLeaf } from "@/components/GoldOrnament";
import { Reveal } from "@/components/Reveal";

export default function FeaturedOffer({ offer, contact }) {
  const { t, lang } = useLang();
  if (!offer || offer.active === false) return null;

  const title = offer[lang]?.title || offer.fr?.title;
  const link = serviceWaLink(contact?.phone_intl || "972555004933", lang, title, offer.price, false);

  return (
    <section className="bg-ivory py-16 md:py-24" data-testid="featured-offer">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] bg-cream border border-gold/30 px-7 py-10 md:px-16 md:py-14">
            <GoldLeaf className="ornament absolute -top-6 end-[-10px] animate-float-slow" />
            <GoldLeaf className="ornament absolute -bottom-8 start-[-14px] rotate-180 animate-float-slow" style={{ animationDelay: "1.5s" }} />
            <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
              <div>
                <span className="inline-block text-xs tracking-[0.2em] uppercase text-gold font-semibold mb-4">
                  {t.offer.badge}
                </span>
                <h3 className="font-serif text-2xl md:text-4xl text-ink leading-tight max-w-md">{title}</h3>
                <p className="mt-4 font-serif text-4xl md:text-5xl text-gold">{offer.price} ₪</p>
              </div>
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0 inline-flex items-center justify-center rounded-full bg-gold px-8 py-4 text-sm md:text-base font-medium text-white hover:brightness-105 hover:scale-[1.03] transition-[filter,transform]"
                data-testid="offer-book-button"
              >
                {offer[lang]?.cta || t.offer.cta}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
